import { useState } from 'react'

import { useConfigureModalController, useModalController, useCloseModal } from '@/atoms'

type ModalState = 'ready' | 'submitting'
type ModalData = Record<string, unknown>

export const modalId = 'resetNotificationEmailCounterModal'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export function useConfigureController() {
  const close = useCloseModal()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      data: {},
      close,
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
